<template>
  <div>
    <vue-final-modal
      v-model="isOpen"
      classes="modal-container"
      content-class="modal-content"
      :click-to-close="false"
      :esc-to-close="false"
      :hide-overlay="false"
    >
      <div class="text-center">
        <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
        </div>
        <div>
          {{ props.message }}
        </div>
      </div>
    </vue-final-modal>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import { VueFinalModal } from 'vue-final-modal'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  message: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:modelValue'])

const isOpen = ref(false)

watch(() => props.modelValue, (newVal) => {
  isOpen.value = newVal
})

watch(() => isOpen.value, (newVal) => {
  emit('update:modelValue', newVal)
})
</script>

<style scoped>
.modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 2rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
}

.spinner-border {
  display: inline-block;
  width: 3rem;
  height: 3rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border .75s linear infinite;
}

@keyframes spinner-border {
  to { transform: rotate(360deg); }
}
</style>
